import PaymentSuccessful from "../../assets/images/PaymentIcons/PaymentSuccessful.gif";
import LottieAnimation from "../public/SuccessAnimation";
import { LoadingIcon } from "./Loading";

export const CancelationSuccess = ({ des2, title, des }) => {
  const contentHTML = { __html: des2 };
  return (
    <div className="mx-auto py-2 relative pb-5">
      <div className="mx-auto sm:w-[300px]">
        <LottieAnimation />
      </div>
      <h2 className="text-f20 font-extrabold">{title}</h2>
      <p className="text-secondary pt-2 pb-4 w-96 text-f14">{des}</p>
      <p
        className="text-secondary pt-2 pb-4 w-96 text-f14"
        dangerouslySetInnerHTML={contentHTML}
      />
    </div>
  );
};
